var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 24,
    viewBox: "0 0 130 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5303 8.21546L13.9171 11.676L2.91235 0.84375H9.82643L17.5303 8.21546Z",
    fill: "#413DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9171 11.6758L17.5303 15.2265L10.1506 22.484H2.91235L13.9171 11.6758Z",
    fill: "#413DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1421 0.84375L21.1373 11.676L17.53 15.2267L13.9167 11.676L17.53 8.21546L25.228 0.84375H32.1421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81773 9.7832H0V13.7364H5.81773V9.7832Z",
    fill: "#413DF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0537 9.7832H29.2361V13.7364H35.0537V9.7832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2414 1.88277C67.1812 1.26355 65.0468 0.938035 62.899 0.915489C57.6294 0.759284 52.354 0.861418 47.0845 0.867425C46.7921 0.882905 46.5009 0.915 46.2122 0.963554V22.4539H51.7115V16.0675C55.4604 16.0675 59.0794 16.2056 62.6868 16.0193C64.8677 15.9052 67.3021 15.7369 69.3652 15.022C72.389 13.9767 73.5855 11.4173 73.5501 8.29319C73.5148 5.36733 72.2122 2.88608 69.2414 1.88277ZM66.1763 10.9908C65.35 11.2497 64.4938 11.3972 63.6299 11.4293C59.8693 11.4834 56.1028 11.4594 52.3363 11.4594C52.1387 11.4491 51.9419 11.427 51.7469 11.3933V5.7038C56.3268 5.7038 60.8418 5.61366 65.3452 5.74585C67.084 5.79991 67.8915 6.78522 67.9977 8.19106C68.113 8.80774 67.987 9.44594 67.6466 9.96915C67.3062 10.4924 66.7785 10.859 66.1763 10.9908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0615 0.879395H85.3558L71.9697 22.5078H77.8641L80.4517 18.2662H95.9716L98.5591 22.5078H104.454L91.0675 0.879395H91.0615ZM93.1835 13.7183H83.228L88.2028 5.55955L93.1835 13.7183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 0.868164H123.452L114.811 11.1657L114.817 11.1777L114.77 11.1657L114.734 11.1717L114.74 11.1657L106.099 0.868164H99.5503L112.07 15.1609V22.4426H117.552V15.0768L130 0.868164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1421 22.4836H24.9038L17.53 15.2261L13.9167 11.6754L17.53 8.21484L21.1373 11.6754L32.1421 22.4836Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dba48215cbab070899f61edab3c59f82.svg";
export { ForwardRef as ReactComponent };